<template>
    <div class="d-flex align-items-center justify-content-center">
        <template>
            <ul class="list-group w-100">
                <template v-for="(result,i) in row.Results">
                    <li class="list-group-item py-25 px-50" v-for="(error,ii) in result.Errors" :key="i+''+ii">
                        <span class="text-nowrap text-secondary font-weight-bolder"> {{ result.SIRA_NO == '13' ? 'BES | ' : result.SIRA_NO == '2' ? 'İcra | ' : null  }} {{ error }} </span>
                    </li>
                    <li class="list-group-item py-25 px-50" v-if="(result.Errors || []).length == 0">
                        <span class="text-nowrap text-success font-weight-bolder"> {{ result.SIRA_NO == '13' ? 'BES | ' : result.SIRA_NO == '2' ? 'İcra | ' : null  }} Başarıyla hesaplandı. 
                            <span class="pl-75" v-if="result.Amount">
                                Tutar: {{ result.Amount }}TL
                            </span>
                        </span>
                    </li>
                </template>
                <li class="list-group-item py-25 px-50" v-if="(row.Results || []).length == 0">
                    <span class="text-nowrap text-muted font-weight-bolder">Henüz bir hesaplama yapılmadı.</span>
                </li>
            </ul>
        </template>
    </div>
</template>

<script>
export default {
    props:{
        row:Object,
        field:Object
    },
}
</script>

<style>

</style>